/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// Reordenar productos agotados al final del grid
(function () {
  function reorderSoldOut() {
    var grids = document.querySelectorAll('.product-list, .collection__products');
    grids.forEach(function (grid) {
      var items = Array.from(grid.children).filter(function (el) {
        return el.classList && (el.classList.contains('product-item') || el.querySelector('.product-item'));
      });
      if (!items.length) return;
      var available = [], soldOut = [];
      items.forEach(function (item) {
        var txt = (item.textContent || '').toLowerCase();
        var hasOutBadge = item.querySelector('[class*="sold-out"], [class*="agotado"]');
        var isOut = hasOutBadge || txt.includes('agotado') || txt.includes('sold out');
        (isOut ? soldOut : available).push(item);
      });
      available.concat(soldOut).forEach(function (el) { grid.appendChild(el); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorderSoldOut);
  } else {
    reorderSoldOut();
  }
  // Re-aplicar cuando se cargan más productos (filtros, paginación AJAX)
  document.addEventListener('collection:updated', reorderSoldOut);
  document.addEventListener('shopify:section:load', reorderSoldOut);
})();

// ---------------------------------------------------------------------------
// Botón "Solicitar Cotización" del carrito (Sirena, 2026-09-30).
// El tema lo trae apuntando a /apps/request-quote (la app vieja que se desinstaló):
// esa dirección da 404. Un cliente alcanzó a hacer clic antes de que cargara
// sirena-cotizacion.js y cayó en el error. Esto lo corrige de una vez, desde el
// propio tema, sin depender de wmsirena.com.
// ---------------------------------------------------------------------------
(function () {
  'use strict';
  var DESTINO = '/cart?cotizar=carrito';
  function arreglar() {
    try {
      var as = document.querySelectorAll('a[href*="/apps/request-quote"]');
      for (var i = 0; i < as.length; i++) as[i].setAttribute('href', DESTINO);
    } catch (e) {}
  }
  arreglar();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arreglar);
  document.addEventListener('shopify:section:load', arreglar);
  document.addEventListener('cart:refresh', arreglar);
  document.addEventListener('cart:updated', arreglar);
  setInterval(arreglar, 1500);   // el carrito se re-pinta por AJAX
  // Por si el clic ocurre antes de que se reescriba el enlace
  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/apps/request-quote"]') : null;
      if (!a) return;
      a.setAttribute('href', DESTINO);
      if (e.button || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      window.location.href = DESTINO;
    } catch (err) {}
  }, true);
})();

// ---------------------------------------------------------------------------
// Tope de cantidad y disponibilidad EN EL CARRITO (Sirena, 2026-09-22).
// Evita el mensaje "Debido a la disponibilidad, solo se añadieron N artículos al
// carrito" cuando el cliente sube la cantidad desde el carrito o el carrito lateral.
// ---------------------------------------------------------------------------
(function () {
  'use strict';
  var cacheProd = {};

  function pedir(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function datosDe(handle) {
    if (cacheProd[handle]) return Promise.resolve(cacheProd[handle]);
    return pedir('/products/' + handle + '.js').then(function (p) {
      var m = {};
      (p.variants || []).forEach(function (v) {
        m[String(v.id)] = { q: v.inventory_quantity, t: v.inventory_management === 'shopify', d: v.inventory_policy === 'deny' };
      });
      cacheProd[handle] = m;
      return m;
    }).catch(function () { return {}; });
  }

  function nota(fila, texto) {
    var p = fila.querySelector('.sst-carrito');
    if (!texto) { if (p) p.remove(); return; }
    if (!p) {
      p = document.createElement('p');
      p.className = 'sst-carrito';
      p.style.cssText = 'margin:4px 0 0;font-size:12px;line-height:1.3;color:#cb1836;font-weight:600;';
      fila.appendChild(p);
    }
    p.textContent = texto;
  }

  function frase(q) { return 'Solo quedan ' + q + (q === 1 ? ' unidad disponible' : ' unidades disponibles'); }

  function revisar() {
    var inputs = Array.prototype.slice.call(document.querySelectorAll('input[data-line].quantity-selector__value'));
    if (!inputs.length) return;
    pedir('/cart.js').then(function (cart) {
      var items = cart.items || [];
      var handles = {};
      items.forEach(function (i) { handles[i.handle] = true; });
      return Promise.all(Object.keys(handles).map(datosDe)).then(function (mapas) {
        var todo = {};
        mapas.forEach(function (m) { for (var k in m) todo[k] = m[k]; });
        inputs.forEach(function (input) {
          var linea = parseInt(input.getAttribute('data-line'), 10);
          var item = items[linea - 1];
          if (!item) return;
          var v = todo[String(item.variant_id)];
          var caja = input.closest('.quantity-selector');
          var fila = caja && caja.parentNode;
          if (!v || !v.t || !v.d || !caja || !fila) { if (fila) nota(fila, ''); return; }
          input.setAttribute('max', v.q);
          var mas = caja.querySelector('[data-action="increase-quantity"]');
          var actual = parseInt(input.value, 10) || item.quantity;
          if (mas) {
            var tope = actual >= v.q;
            mas.disabled = tope;
            mas.style.opacity = tope ? '.4' : '';
            mas.style.pointerEvents = tope ? 'none' : '';
          }
          nota(fila, actual >= v.q ? frase(v.q) : '');
          if (!input.__sst) {
            input.__sst = true;
            input.addEventListener('change', function () {
              var n = parseInt(input.value, 10) || 1;
              if (n > v.q) { input.value = v.q; nota(fila, frase(v.q)); }
            });
          }
        });
      });
    }).catch(function () {});
  }

  function arrancar() { revisar(); setTimeout(revisar, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  ['cart:updated', 'cart:refresh', 'product:added', 'shopify:section:load'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(revisar, 600); });
    document.documentElement.addEventListener(ev, function () { setTimeout(revisar, 600); });
  });
})();
